import React from "react";
import { motion } from "framer-motion";

export default function AboutSection() {
  return (
    <section className="py-20 text-center px-6">
      <motion.h2
        className="text-3xl font-bold text-purple-300 mb-6"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        About Me
      </motion.h2>
      <motion.p
        className="text-gray-300 max-w-3xl mx-auto leading-relaxed"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
      >
        I'm Daniel, a Software Engineer passionate about full-stack development and modern UI/UX.
        I enjoy working with JavaScript, React, Flutter, and backend systems in Node.js or Java.
        My focus is on building performant and elegant solutions that bring real value to users.
      </motion.p>
    </section>
  );
}
